export enum StatusLabelStatus {
    aborted = 'aborted',
    accepted = 'accepted',
    acceptedRequester = 'acceptedRequester',
    analyzed = 'analyzed',
    answered = 'answered',
    answeredFirstRound = 'answeredFirstRound',
    answeredSecondRound = 'answeredSecondRound',
    assetNeeded = 'assetNeeded',
    beingGraded = 'beingGraded',
    beingPerformed = 'beingPerformed',
    cancelled = 'cancelled',
    closed = 'closed',
    completed = 'completed',
    dataTransferred = 'dataTransferred',
    dischargeCompleted = 'dischargeCompleted',
    dischargeDraft = 'dischargeDraft',
    dischargeSent = 'dischargeSent',
    draftConsult = 'draftConsult',
    draftContact = 'draftContact',
    draftCounseling = 'draftCounseling',
    draftReferral = 'draftReferral',
    draftRequest = 'draftRequest',
    failed = 'failed',
    inAnalysis = 'inAnalysis',
    inProgress = 'inProgress',
    intakeCompleted = 'intakeCompleted',
    intakeCompletedAdmin = 'intakeCompletedAdmin',
    intakeDraft = 'intakeDraft',
    intakeSent = 'intakeSent',
    invited = 'invited',
    newContact = 'newContact',
    notYetSent = 'notYetSent',
    rejected = 'rejected',
    rejectedAndArchived = 'rejectedAndArchived',
    rejectedAndResent = 'rejectedAndResent',
    requested = 'requested',
    saved = 'saved',
    sent = 'sent',
    sentFirstRound = 'sentFirstRound',
    sentSecondRound = 'sentSecondRound',
    started = 'started',
    supervised = 'supervised',
    toAccept = 'toAccept',
    toAcceptReferral = 'toAcceptReferral',
    toAnalyze = 'toAnalyze',
    toAnswer = 'toAnswer',
    toGrade = 'toGrade',
    toPerform = 'toPerform',
    toProcess = 'toProcess',
    toSupervise = 'toSupervise',
    withAdmin = 'withAdmin',
    withAnalysis = 'withAnalysis',
    withBiometrician = 'withBiometrician',
    withColleague = 'withColleague',
    withGrader = 'withGrader',
    withPatient = 'withPatient',
    withSpecialist = 'withSpecialist',
    withSupervisor = 'withSupervisor',
}
